import { Link } from "../../typography/Link";
import { Text } from "../../typography/Text";

type FileNameProps = {
	url: string;
	name: string;
	allowDownload?: boolean;
};

export const FileName = ({ url, name, allowDownload }: FileNameProps) => {
	const canDownload = url !== "" && (allowDownload || !url.startsWith("blob:"));

	if (!canDownload) {
		return (
			<Text className="truncate" size="sm">
				{name}
			</Text>
		);
	}

	return (
		<Link href={url} target="_blank" download={allowDownload ? name : undefined} size="sm" className="truncate">
			{name}
		</Link>
	);
};
